import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export type SelectedAnswers = {
	question_id: string;
	answer_id: string;
};

export interface SaveOnboardingBody {
	onboarding_questions: SelectedAnswers[];
}

export async function saveOnboarding({
	onboarding_questions,
}: SaveOnboardingBody): Promise<
	{ status: "success" } | { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.post("/onboarding/store", {
			onboarding_questions,
		});

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
			message: string;
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
